import {
  Checkbox,
  ClickAwayListener,
  createStyles,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Paper,
  Popper,
} from "@material-ui/core"
import { MoreVertRounded } from "@material-ui/icons"
import PopupState, { bindPopper, bindToggle } from "material-ui-popup-state"
import React from "react"
import { IDataTableColumn } from "react-data-table-component"

const useStyles = makeStyles(() =>
  createStyles({
    iconButton: {
      padding: "6px",
    },
  }),
)

interface Props {
  columns: IDataTableColumn[]
  hiddenColumns: string[]
  setHiddenColumns: (columns: string[]) => void
}

const OmitColumnSelector = (props: Props): JSX.Element => {
  const classes = useStyles()
  const { columns, hiddenColumns, setHiddenColumns } = props

  const handleToggle = (column: IDataTableColumn) => {
    if (hiddenColumns.includes(column.name as string)) {
      //show element
      setHiddenColumns(Array.from(hiddenColumns.filter((c) => c !== column.name)))
    } else {
      //hide element
      setHiddenColumns(Array.from(hiddenColumns.concat([column.name as string])))
    }
  }

  return (
    <PopupState variant="popper" popupId="demo-popup-popper">
      {(popupState) => (
        <div>
          <IconButton className={classes.iconButton} {...bindToggle(popupState)} aria-label="open">
            <MoreVertRounded />
          </IconButton>
          <Popper {...bindPopper(popupState)}>
            <ClickAwayListener onClickAway={popupState.close}>
              <Paper>
                <List>
                  {columns.map((column, idx) => (
                    <ListItem key={idx} dense button onClick={() => handleToggle(column)}>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={!hiddenColumns.includes(column.name as string)}
                          tabIndex={-1}
                          color="primary"
                        />
                      </ListItemIcon>
                      <ListItemText primary={column.name} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </ClickAwayListener>
          </Popper>
        </div>
      )}
    </PopupState>
  )
}

export default OmitColumnSelector
